var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfReportColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 73.5,
    viewBox: "0 0 49 73.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28702",
    "data-name": "Group 28702",
    transform: "translate(-1150 -547.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13806",
    "data-name": "Rectangle 13806",
    width: 45,
    height: 59,
    rx: 8,
    transform: "translate(1152 560)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13806_-_Outline",
    "data-name": "Rectangle 13806 - Outline",
    d: "M8-2H37A10.011,10.011,0,0,1,47,8V51A10.011,10.011,0,0,1,37,61H8A10.011,10.011,0,0,1-2,51V8A10.011,10.011,0,0,1,8-2ZM37,57a6.007,6.007,0,0,0,6-6V8a6.007,6.007,0,0,0-6-6H8A6.007,6.007,0,0,0,2,8V51a6.007,6.007,0,0,0,6,6Z",
    transform: "translate(1152 560)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13807",
    "data-name": "Rectangle 13807",
    width: 19,
    height: 7,
    rx: 1,
    transform: "translate(1165 556.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13807_-_Outline",
    "data-name": "Rectangle 13807 - Outline",
    d: "M1-2H18a3,3,0,0,1,3,3V6a3,3,0,0,1-3,3H1A3,3,0,0,1-2,6V1A3,3,0,0,1,1-2ZM17,2H2V5H17Z",
    transform: "translate(1165 556.5)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13808",
    "data-name": "Rectangle 13808",
    d: "M5,0H5a5,5,0,0,1,5,5V6A1,1,0,0,1,9,7H1A1,1,0,0,1,0,6V5A5,5,0,0,1,5,0Z",
    transform: "translate(1169.5 549.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13808_-_Outline",
    "data-name": "Rectangle 13808 - Outline",
    d: "M5-2a7.008,7.008,0,0,1,7,7V6A3,3,0,0,1,9,9H1A3,3,0,0,1-2,6V5A7.008,7.008,0,0,1,5-2ZM8,5A3,3,0,0,0,2,5Z",
    transform: "translate(1169.5 549.5)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13809",
    "data-name": "Rectangle 13809",
    width: 29,
    height: 37,
    rx: 3,
    transform: "translate(1160 573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13809_-_Outline",
    "data-name": "Rectangle 13809 - Outline",
    d: "M3-2H26a5.006,5.006,0,0,1,5,5V34a5.006,5.006,0,0,1-5,5H3a5.006,5.006,0,0,1-5-5V3A5.006,5.006,0,0,1,3-2ZM26,35a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V34a1,1,0,0,0,1,1Z",
    transform: "translate(1160 573)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_358",
    "data-name": "Line 358",
    d: "M29,2H0V-2H29Z",
    transform: "translate(1160 582)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_359",
    "data-name": "Line 359",
    d: "M29,2H0V-2H29Z",
    transform: "translate(1159 592)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_360",
    "data-name": "Line 360",
    d: "M29,2H0V-2H29Z",
    transform: "translate(1160 602)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_361",
    "data-name": "Line 361",
    d: "M2,36H-2V0H2Z",
    transform: "translate(1170.5 573.5)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_362",
    "data-name": "Line 362",
    d: "M2,36H-2V0H2Z",
    transform: "translate(1179.5 573.5)",
    fill: "#024D82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfReportColor);
export default __webpack_public_path__ + "static/media/pdf-report-color.312f161dcf43796e10c49e2b05964902.svg";
export { ForwardRef as ReactComponent };